import axios from 'axios'

export const getPostOffices = (id, params) => {
  return axios.get('post-offices/' + id, {params: params})
}

export const addPostOffices = (data) => {
  return axios.post('post-offices', data)
}

export const updatePostOffices = (id, data) => {
  return axios.put('post-offices/' + id, data)
}

export const deletePostOffices = (id) => {
  return axios.delete('post-offices/' + id)
}

export const restorePostOffice = (id) => {
  return axios.post('post-offices/' + id + '/restore', {})
}



// WEBPACK FOOTER //
// ./src/api/postOffices.js